import { theme } from "styles/theme";

const getBorderColor = (
  inputValue: string,
  color = theme.brand.color.primary.pure
) => {
  if (!inputValue) {
    return theme.brand.color.input.border;
  }

  return color;
};

const inputUtil = {
  getBorderColor: (value: string, color?: string ) => getBorderColor(value, color),
};

export default inputUtil;
